/**
 * @generated SignedSource<<42ae49a20b7854e2d56ff59a066ae4f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingAboutScreenQuery$variables = Record<PropertyKey, never>;
export type OnboardingAboutScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OnboardingAboutView_query">;
};
export type OnboardingAboutScreenQuery = {
  response: OnboardingAboutScreenQuery$data;
  variables: OnboardingAboutScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingAboutScreenQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OnboardingAboutView_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OnboardingAboutScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "biography",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthdate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closestCity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "genderOther",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightCm",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightFt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "heightIn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "instagram",
                "storageKey": null
              },
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pronounId",
                "storageKey": null
              },
              (v0/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMetricSystem",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "GenderConnection",
        "kind": "LinkedField",
        "name": "genders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Gender",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isOther",
                "storageKey": null
              },
              (v1/*:: as any*/),
              (v0/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "genders(orderBy:[\"SEQUENCE_ASC\"])"
      },
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "PronounConnection",
        "kind": "LinkedField",
        "name": "pronouns",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pronoun",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              (v0/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": "pronouns(orderBy:[\"SEQUENCE_ASC\"])"
      }
    ]
  },
  "params": {
    "cacheID": "efe67fd2b70df4ac4a9b5c87e613a55d",
    "id": null,
    "metadata": {},
    "name": "OnboardingAboutScreenQuery",
    "operationKind": "query",
    "text": "query OnboardingAboutScreenQuery {\n  ...OnboardingAboutView_query\n}\n\nfragment GenderSelectInput_query on Query {\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n}\n\nfragment HeightInput_query on Query {\n  currentUser {\n    isMetricSystem\n    id\n  }\n}\n\nfragment OnboardingAboutView_query on Query {\n  currentUser {\n    rowId\n    profile {\n      biography\n      birthdate\n      closestCity\n      genderId\n      genderOther\n      heightCm\n      heightFt\n      heightIn\n      instagram\n      name\n      pronounId\n      rowId\n      id\n    }\n    id\n  }\n  genders(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      isOther\n      name\n      rowId\n      id\n    }\n  }\n  ...GenderSelectInput_query\n  ...HeightInput_query\n  ...PronounSelectInput_query\n}\n\nfragment PronounSelectInput_query on Query {\n  pronouns(orderBy: [SEQUENCE_ASC]) {\n    nodes {\n      name\n      rowId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "29600cf0d007fba46d3e14189c40c5d0";

export default node;
